import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ddLists } from "../../configs/dropdownLists";
import { useEffect } from "react";
import { getValueByText, getJsonItem } from "../../services/helperLib";
export default function Dropdown(_a) {
    var field = _a.field, onChange = _a.onChange, onBlur = _a.onBlur, touched = _a.touched;
    var fieldConfig = field.config;
    var list = typeof fieldConfig["answerOptions"] === "string"
        ? ddLists[fieldConfig["answerOptions"]]
        : fieldConfig["answerOptions"] || [];
    var showError = !field.isValid && touched;
    var showSuccess = field.isValid && field.fieldValue !== "";
    var fieldClass = [
        fieldConfig.className || "",
        showError ? "field-error" : "",
        showSuccess ? "field-success" : ""
    ]
        .filter(Boolean)
        .join(" ")
        .trim();
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    // Auto-populate state dropdown from stored geo info
    useEffect(function () {
        var _a;
        if (((_a = fieldConfig.fieldId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "state" && !field.fieldValue && list.length > 0) {
            var stored = getJsonItem("userGeoInfo", localStorage);
            var stateFromSession = sessionStorage.getItem("selectedState");
            //No State found Default to CA as per US395994
            var userState = stateFromSession || (stored ? stored.User_State : "California");
            if (userState) {
                var stateCode = getValueByText(userState, list);
                if (stateCode) {
                    onChange(stateCode);
                }
            }
        }
    }, [fieldConfig.fieldId, list, onChange]);
    return (_jsxs("div", { className: "dropdown", children: [fieldConfig.labelText ? (_jsx("label", { htmlFor: fieldConfig.fieldId, children: fieldConfig.labelText })) : (_jsx("label", { htmlFor: fieldConfig.fieldId, className: "visually-hidden", children: fieldConfig.customDefaultText || "Select an option" })), _jsx("div", { className: "select-wrapper", children: _jsxs("select", { id: fieldConfig.fieldId, className: fieldClass, value: field.fieldValue || "", onChange: handleChange, onBlur: onBlur, "aria-invalid": showError ? "true" : "false", autoComplete: fieldConfig.autoComplete || "off", children: [_jsx("option", { value: "", disabled: true, children: fieldConfig.customDefaultText || "Please select" }), list.map(function (option, i) { return (_jsx("option", { value: option.value, disabled: option.value === "null" || option.value === "", children: option.text }, "".concat(fieldConfig.fieldId, "-").concat(i))); })] }) })] }));
}
